module.exports = __webpack_public_path__ + "img/c7.712b22b5.png";